import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import SearchMyBooking from "app/pages/Account/SearchMyBooking/SearchMyBooking";
import { bindActionCreators } from "redux";
import { searchBooking } from "app/pages/Account/SearchMyBooking/searchMyBookingActionCreators";
import { useCallback, useContext, useState } from "react";
import PropTypes from "prop-types";
import AppGlobalsContext from "app/AppGlobalsContext";
import { updateEmail } from "app/reducers/emailActionCreators";
import { HTTP_STATUS_CODES } from "app/constants";
import { isWhiteLabel } from "app/reducers/brandSelector";
import { getBrandDisplayName } from "app/reducers/partnerSelector";
import { fetchSearchMyBooking } from "app/pages/Account/SearchMyBooking/searchMyBookingActionCreators";
import { SEARCH_MY_BOOKING_WITH_OTP_BRANDS } from "app/constants";
import isEmpty from "lodash/isEmpty";

const searchBookingErrorGenerate = status =>
	({
		[HTTP_STATUS_CODES.NOT_FOUND]: "error.booking.not.found.error",
		[HTTP_STATUS_CODES.TOO_MANY_REQUEST]: "error.booking.too.many.request.error",
	})[status] || "error.generic";

const SearchMyBookingContainer = ({
	fetchSearchMyBooking = () => {},
	searchBooking = () => {},
	updateEmail = () => {},
	isWhiteLabel,
	brandDisplayName,
}) => {
	const [myBookingError, setMyBookingError] = useState();
	const { brand, shop, partnerCode } = useContext(AppGlobalsContext);
	const navigate = useNavigate();
	const usingOtp = SEARCH_MY_BOOKING_WITH_OTP_BRANDS.includes(brand);

	const handleFormSuccessWithAPIMembre = useCallback(
		(bookingReference, email) => {
			return searchBooking({
				brandDisplayName,
				bookingReference,
				email,
				brand: brand?.toUpperCase(),
				partnerCode,
				shop,
			})
				.then(res => {
					if (res.status === HTTP_STATUS_CODES.OK) {
						setMyBookingError(null);
						updateEmail(email);
						navigate(`/otp?token=${res?.data?.token}`, {
							replace: true,
							state: {
								email,
								bookingReference,
							},
						});
					} else {
						setMyBookingError(searchBookingErrorGenerate(res.status));
					}

					return res;
				})
				.catch(err => {
					const status = err?.response?.status;
					setMyBookingError(searchBookingErrorGenerate(status));
					return Promise.reject(err);
				});
		},
		[brand]
	);

	const handleFormSuccessWithCustomerService = useCallback(
		(bookingReference, email) => {
			return fetchSearchMyBooking({ bookingReference, email, brand }).then(res => {
				if (res.status === 200 && !isEmpty(res?.data?.booking)) {
					setMyBookingError(null);
					updateEmail(email);
					navigate(`/account/mybookings/${bookingReference}`, { replace: true });
				} else {
					setMyBookingError(searchBookingErrorGenerate(res.status));
				}
			});
		},
		[brand]
	);

	return (
		<SearchMyBooking
			onFormSuccess={usingOtp ? handleFormSuccessWithAPIMembre : handleFormSuccessWithCustomerService}
			myBookingError={myBookingError}
			setMyBookingError={setMyBookingError}
			isWhiteLabel={isWhiteLabel}
		/>
	);
};

const mapStateToProps = state => {
	return {
		isWhiteLabel: isWhiteLabel(state),
		brandDisplayName: getBrandDisplayName(state),
	};
};

const mapDispatchToProps = dispatch => bindActionCreators({ fetchSearchMyBooking, searchBooking, updateEmail }, dispatch);

SearchMyBookingContainer.propTypes = {
	fetchSearchMyBooking: PropTypes.func,
	searchBooking: PropTypes.func,
	isWhiteLabel: PropTypes.bool,
	updateEmail: PropTypes.func,
	brandDisplayName: PropTypes.string,
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchMyBookingContainer);
